import React from 'react';
import { Box, CssBaseline, ThemeProvider, createTheme } from '@mui/material';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';

import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Experience from './components/Experience';
import Tools from './components/Tools';
import Footer from './components/Footer';
import ExchangeMonitor from './components/ExchangeMonitor';


// 创建符合苹果审美的自定义主题
const theme = createTheme({
  palette: {
    primary: {
      light: '#7AA095',
      main: '#4D7C6F', // 宫崎骏风格的绿色
      dark: '#2C5A4D',
    },
    secondary: {
      light: '#FAF5EB',
      main: '#F0E6D2', // 暖米色
      dark: '#E5D9C0',
    },
    background: {
      default: '#ffffff',
      paper: '#ffffff',
    },
    text: {
      primary: '#1d1d1f', // 苹果深灰色文本
      secondary: '#86868b', // 苹果二级文本颜色
    },
  },
  typography: {
    fontFamily: [
      'SF Pro Display',
      'SF Pro Text',
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
    ].join(','),
    h1: {
      fontWeight: 600,
      letterSpacing: '-0.015em',
    },
    h2: {
      fontWeight: 600,
      letterSpacing: '-0.01em',
    },
    h3: {
      fontWeight: 600,
      letterSpacing: '-0.01em',
    },
    h4: {
      fontWeight: 500,
      letterSpacing: '-0.01em',
    },
    body1: {
      lineHeight: 1.5,
      letterSpacing: '0.01em',
    },
    body2: {
      lineHeight: 1.6,
      letterSpacing: '0.01em',
    },
    button: {
      textTransform: 'none',
      fontWeight: 500,
    },
  },
  shape: {
    borderRadius: 12, // 苹果风格的圆角
  },
  shadows: [
    'none',
    '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
    '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
    // ... 保留默认其他阴影
    ...createTheme().shadows.slice(3),
  ],
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: '9999px', // 苹果风格的圆形按钮
          padding: '8px 20px',
          fontSize: '0.9rem',
          fontWeight: 500,
        },
        contained: {
          boxShadow: 'none',
          '&:hover': {
            boxShadow: 'none',
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 16,
          boxShadow: '0 4px 8px -2px rgba(0, 0, 0, 0.05), 0 2px 4px -1px rgba(0, 0, 0, 0.03)',
        },
      },
    },
  },
});

// 主页组件
const HomePage = () => (
  <>
    <Navbar />
    <Hero />
    <Experience />
    <Tools />
    <Footer />
  </>
);

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <Box sx={{ 
          display: 'flex', 
          flexDirection: 'column',
          minHeight: '100vh'
        }}>
          <Routes>
            {/* 主页路由 */}
            <Route path="/" element={<HomePage />} />

            {/* 汇率监控页面路由 */}
            <Route path="/exchange-monitor" element={
              <>
                <Navbar />
                <ExchangeMonitor />
                <Footer />
              </>
            } />

          </Routes>
        </Box>
      </Router>
    </ThemeProvider>
  );
}

export default App;
